import "./insDeletePortfolioAction.scss";
import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonSizeEnum, AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import { isEqual } from "lodash";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { insPortfoliosStateId } from "common/constants";
import { MessagesDialogFunctionName } from "components/frame/helper";
import { appInsightEvents, language } from "language/default";
import { appInsightsTrackEvent } from "plugins/app-insight-init";
import { setMessagesDialog } from "store/messages-dialog";
import { getCurrentLocalTime } from "common/date-utils";
export const InsDeletePortfolioAction = (props) => {
    const selectedRows = useSelector((state) => state.grids.state[insPortfoliosStateId]?.selectedRows, isEqual) ?? [];
    const dispatch = useDispatch();
    const handlePortfolioDeletion = () => {
        appInsightsTrackEvent({ name: appInsightEvents.customEvents.names.PortfolioDeletion, properties: { LocalTimestamp: getCurrentLocalTime() } });
        dispatch(setMessagesDialog({ functionName: MessagesDialogFunctionName.DeletePortfolio,
            hasCustomFooter: true,
            isPrimaryButtonDelete: true,
            messages: [{ message: language.en.modal.portfolioCreation.portfolioDeletion.deletePortfolioAlertFirstLine }],
            title: language.en.modal.portfolioCreation.portfolioDeletion.deletePortfolioAlertHeader,
            type: "alert-with-options" }));
    };
    return React.createElement(React.Fragment, null,
        React.createElement(AuxButton, { size: AuxButtonSizeEnum.SMALL, type: AuxButtonTypeEnum.DESTRUCTIVE_PRIMARY, isDisabled: selectedRows.length === 0 || props.isDisabled, onClick: handlePortfolioDeletion, label: language.en.modal.portfolioCreation.portfolioDeletion.deletePortfolio }));
};
